const FOCAVEIS =
  "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])";

// Mantem o Tab dentro do container (drawer/modal) enquanto ele estiver aberto.
export default function prenderFoco(event, container) {
  if (event.key !== "Tab" || !container) return;

  const focaveis = Array.from(container.querySelectorAll(FOCAVEIS)).filter(
    (el) => el.offsetParent !== null
  );

  if (focaveis.length === 0) return;

  const primeiro = focaveis[0];
  const ultimo = focaveis[focaveis.length - 1];

  if (event.shiftKey && document.activeElement === primeiro) {
    event.preventDefault();
    ultimo.focus();
  } else if (!event.shiftKey && document.activeElement === ultimo) {
    event.preventDefault();
    primeiro.focus();
  }
}
